import { useState } from 'react'
import {
	Box,
	Button,
	Card,
	Chip,
	IconButton,
	Modal,
	TextField,
	Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useDispatch } from 'react-redux'
import { updateProfile } from '../../../features/authSlice'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import styles from './index.module.scss'
import CommonModal from '../../atoms/modal/CommonModal'
import InputCustom from '../../atoms/input/InputCustom'

export const ServicesCard = ({ formData, cardStyle, editable }) => {
	const dispatch = useDispatch()
	const [open, setOpen] = useState(false)
	const [newService, setNewService] = useState('')
	const [newServices, setNewServices] = useState([])

	const handleOpen = () => {
		setOpen(true)
		setNewServices(formData.services)
	}

	const handleDelete = (deletedService) => {
		const newList = newServices.filter(
			(service) => service !== deletedService
		)
		setNewServices(newList)
	}

	const handleAdd = () => {
		if (newService.length > 0) {
			setNewServices([...newServices, newService])
			setNewService('')
		}
	}

	const handleChange = (e) => {
		setNewService(e.target.value)
	}

	const handleSave = () => {
		dispatch(updateProfile({ services: newServices }))
	}

	return (
		<>
			<CommonModal
				open={open}
				handleClose={() => setOpen(false)}
				heading="Edit Services"
				footerContent={
					<>
						<ButtonCustom
							variant="default"
							size="lg"
							onClick={handleSave}
						>
							Save
						</ButtonCustom>
					</>
				}
			>
				<div>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							gap: '1rem',
						}}
					>
						<InputCustom
							value={newService}
							onChange={handleChange}
						/>
						<ButtonCustom
							variant="outlined"
							size="md"
							onClick={handleAdd}
						>
							Add
						</ButtonCustom>
					</Box>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							gap: '8px',
							flexWrap: 'wrap',
							alignItems: 'center',
							py: '1rem',
						}}
					>
						{newServices?.map((service, i) => (
							<ButtonCustom
								variant="pilled"
								size="md"
								onClick={() => handleDelete(service)}
								style={{
									width: 'max-content',
								}}
							>
								{service}
								<img
									src="/images/modal-close-icon.svg"
									alt="close"
									style={{
										width: '14px',
										height: '14px',
									}}
								/>
							</ButtonCustom>
						))}
					</Box>
				</div>
			</CommonModal>
			<div
				sx={cardStyle}
				className={`${styles.cardWrp} ${styles.serviceInfo}`}
			>
				<div className={styles.infoHeader}>
					<Typography
						variant="h5"
						gutterBottom
						sx={{ fontWeight: 'bold' }}
					>
						Services
					</Typography>
					{editable && (
						<IconButton
							component="label"
							onClick={handleOpen}
							className={styles.editIcon}
							disableRipple
						>
							<img
								src="/images/edit-icon.svg"
								alt="business pic"
							/>
						</IconButton>
					)}
				</div>
				<div className={styles.serviceChipsWrp}>
					{formData.services?.map((service, i) => (
						<ButtonCustom
							key={i}
							label={service}
							variant="pilled"
							className={styles.chip}
						>
							{service}
						</ButtonCustom>
					))}
				</div>
			</div>
		</>
	)
}
